import { render, staticRenderFns } from "./Exercise2-2.vue?vue&type=template&id=7077ec9a&"
import script from "./Exercise2-2.vue?vue&type=script&lang=js&"
export * from "./Exercise2-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports